import './MgmntSignDocCard.scss'
import '../SignDocCard/SignDocCard.scss';
import {Button} from "../../Form/Button/Button";
import {buttonColors} from "../../Pickers/InputTheme";
import React, {useContext, useState} from "react";
import {useNavigate} from "react-router-dom";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {get} from "lodash";
import {ConfirmationModal} from "../../Smart/confirmationModal/confirmationModal";
import {deleteSignDocAPI} from "../../../Services/api";
import {SignDocTypes, SignDocUploadStatus} from "../SignDocLib";
import useSignDocTypes from '../../../Hooks/useSignDocTypes';
import {I18nReactContext} from "../../../contexts/I18nContext";
import {invalidateQueries, queryKeys} from "../../Hooks/useQueryHooks";

export const MgmntSignDocCard = ({signDoc, onAfterEditComplete, noButton}) => {
    const {i18n} = useContext(I18nReactContext);
    const { getMgmntImageIcon } = useSignDocTypes();
    const navigate = useNavigate();
    const [hover, setHover] = React.useState(false)
    const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)

    const type = signDoc.type
    const openDeleteConfirmModal = () => {
        setDeleteConfirmModalOpen(true)
    }
    const closeDeleteConfirmModal = () => {
        setDeleteConfirmModalOpen(false)
    }

    /**
     * Handle SignDoc edit button click
     * Navigates to version management page for the SignDoc
     */
    const onSignDocSelected = () => {
        navigate(`/learningManagement/signDoc/${signDoc.id}/versions`);
    }

    const onMouseEnter = () => {
        setHover(true)
    }
    const onMouseLeave = () => {
        setHover(false)
    }
    const handleDeleteClick = () => {
        if(!hover){
            return
        }
        openDeleteConfirmModal()
    }
    
    const deleteSignDoc = async () => {
        if(type === SignDocTypes.REGULAR_COURSE){
            return
        }
        try {
            setIsDeleting(true)
            await deleteSignDocAPI({signDocId: signDoc.id, deleteAllVersions: true })
            invalidateQueries({queryKeys: [
                queryKeys.uniqueSignDocs(false),
                queryKeys.uniqueSignDocs(true),
                queryKeys.allAdminSignDocs(false),
                queryKeys.allAdminSignDocs(true),
                queryKeys.adminCreatedSignDocTypes(false),
                queryKeys.adminCreatedSignDocTypes(true)
            ]})
            closeDeleteConfirmModal()
            onAfterEditComplete && onAfterEditComplete()
        } catch (error) {
            console.error('Error deleting SignDoc:', error)
        } finally {
            setIsDeleting(false)
        }
    }
    // Get upload status display
    const getUploadStatusDisplay = () => {
        const currentUploadStatus = signDoc.uploadStatus || SignDocUploadStatus.READY;
        switch (currentUploadStatus) {
            case SignDocUploadStatus.UPLOADING:
                return {
                    status: SignDocUploadStatus.UPLOADING,
                    message: i18n.translate('LearningManagementPage.signDocCard.uplodingSignDoc.uploadInProgress'),
                    textClassName: 'upload-status-text uploading',
                    disabled: true
                };
                case SignDocUploadStatus.FAILED:
                    return {
                        status: SignDocUploadStatus.FAILED,
                        message: i18n.translate('LearningManagementPage.signDocCard.uplodingSignDoc.uploadFailed'),
                        textClassName: 'upload-status-text failed',
                        disabled: true
                    };
            default:
                return {
                    status: SignDocUploadStatus.READY,
                    message: i18n.translate('LearningManagementPage.signDocCard.versionManagement'),
                    textClassName: '',
                    disabled: false
                };
        }
    };

    const uploadStatusDisplay = getUploadStatusDisplay();

    return <div className={`MgmntSignDocCard SignDocCard ${noButton ? 'noButton' : ''}`}>
        <div className={`signDocCardImage ${type === SignDocTypes.REGULAR_COURSE ? 'round' : ''}`}>
            <img src={signDoc.imgSrc || getMgmntImageIcon({ type: signDoc.type })}/>
        </div>
        <div className="signDocCardContent" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <div className={`signDocTitle ${get(signDoc, 'docName.length') > 20 ? 'small' : ''}`}>{signDoc.docName}</div>
            <div className="signDocDescription" title={signDoc.description}>{signDoc.description}</div>
              {get(uploadStatusDisplay, 'status') === SignDocUploadStatus.UPLOADING && (
                <div className={uploadStatusDisplay.textClassName}>
                    {uploadStatusDisplay.message}
                </div>
            )}
            { noButton ? '' : <div className="signDocButton">
                <Button color={buttonColors.GOLD}
                        disabled={noButton || uploadStatusDisplay?.disabled}
                        onClick={onSignDocSelected}
                        style={{width: '100%'}}
                        text={uploadStatusDisplay.message}
                        type="button"
                        component="button"
                        className=""
                        icon={null}
                        actionSucceeded={false}
                        actionSucceededText=""
                        actionFailed={false}
                        disableWithoutPermissions={null}
                        hideWithoutPermissions={null}
                        withArrowIcon={false}
                        customRef={null}/>
            </div>}
            { noButton || get(uploadStatusDisplay, 'status') !== SignDocUploadStatus.READY ? '' : <div className={`deleteIcon ${hover ? 'hover' : ''}`}>
                <div className="deleteIconContent">
                    <DeleteForeverIcon onClick={handleDeleteClick}/>
                </div>
            </div>}
        </div>
        {deleteConfirmModalOpen ? <ConfirmationModal
            confirmationModalOpen={deleteConfirmModalOpen}
            onCloseConfirmationModal={closeDeleteConfirmModal}
            title={i18n.translate('LearningManagementPage.signDocCard.deleteModal.title')}
            message={i18n.translate('LearningManagementPage.signDocCard.deleteModal.text')}
            messageBody={<div>
                <div>{i18n.translate('LearningManagementPage.signDocCard.deleteModal.signDocName')}: <span style={{fontWeight: 'bold'}}>{signDoc.docName}</span></div>
                {signDoc.groupRootId && (
                    <div style={{marginTop: '15px', color: '#dc2626', fontWeight: 'bold'}}>
                        {i18n.translate('LearningManagementPage.signDocCard.deleteModal.warningAllVersions')}
                    </div>
                )}
            </div>}
            onConfirm={deleteSignDoc}
            onCancel={closeDeleteConfirmModal}
            confirmText={i18n.translate('LearningManagementPage.signDocCard.deleteModal.confirm')}
            cancelText={i18n.translate('LearningManagementPage.signDocCard.deleteModal.cancel')}
            isLoading={isDeleting}
        /> : ''}
    </div>
}